interface Feature extends GeoJSON.Feature<GeoJSON.Geometry> {
  layer: {
    source: string,
  };
}

export default function getLocationFeature(features: Feature[]) {
  return features.reduce(
    (accumulator: {}[], feature) => {
      if (feature.layer.source === 'geojson') {
        accumulator.push(feature);
      }
      return accumulator;
    },
    [],
  );
}
